var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#252525",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96818 0.142158C7.33146 2.23459 7.68377 5.59264 9.3519 7.31941C11.0809 9.10915 14.4812 9.53068 16.6559 6.86029C16.6823 6.93444 16.7118 6.98929 16.7209 7.04617C16.8904 8.12388 16.7798 9.18025 16.4732 10.2214C15.9868 11.876 15.0649 13.2422 13.7136 14.3026C12.7409 15.0655 11.6343 15.553 10.4169 15.8202C8.78333 16.1797 7.20861 15.9867 5.6877 15.3743C4.41656 14.8623 3.36065 14.0304 2.5139 12.9395C1.17067 11.2077 0.59601 9.22799 0.864047 7.08071C1.22143 4.22342 2.72813 2.09543 5.33032 0.811534C6.72736 0.121843 8.21274 -0.155455 9.77223 0.0852765C9.82705 0.0934025 9.87985 0.116765 9.96818 0.142158Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.9f199ac99a646ba5b124080b2be2efbb.svg";
export { ForwardRef as ReactComponent };